import { render, staticRenderFns } from "./DescriptionReviews.vue?vue&type=template&id=4af06578&scoped=true&"
import script from "./DescriptionReviews.vue?vue&type=script&lang=js&"
export * from "./DescriptionReviews.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionReviews.vue?vue&type=style&index=0&id=4af06578&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af06578",
  null
  
)

export default component.exports